/* eslint-disable @typescript-eslint/no-explicit-any */

import Wrapper from '@/common/wrapper/Wrapper';
import { useRouter } from '@/hooks/hooks';
import { Button, Radio } from 'antd';
import { useEffect, useState } from 'react';
import style from './Analysis.module.less';
import {addLogoPt, getAllCourseSplit} from '@/service/exam/analysis';
import { allCourseSplitColumns } from './const';
import { exportFile } from 'table-xlsx';
import { schoolAreaRecord } from '@/utils/const';
import { filterNull } from '@/utils';
import layer from '@/utils/layer';
import { formatAnalysisTableRows, formatAnalysisTableValue } from './format';

const AllCourseSplit = () => {

  const router = useRouter();
  const { name, examid } = router.getSearchParams();
  const [split, setSplit] = useState(5);
  const [list, setList] = useState<Record<string, any>[]>([]);
  const [columns, setColumns] = useState(allCourseSplitColumns);


  const load = async (s: number) => {
    try {
      layer.loading();
      const { data } = await getAllCourseSplit(examid, s);
      setColumns([
        ...allCourseSplitColumns,
        ...data.scoreGroups.map(i => ({
          title: i.name,
          dataIndex: i.name,
          width: i.name.length * 10 + 20
        }))
      ]);

      const newList = [
        ...data.schoolStatList.map(i => {
          return {
            ...i,
            ...data.scoreGroups.reduce((a, c) => {
              return { ...a, [c.name]: i.scoreGroupCountInfo ? i.scoreGroupCountInfo[c.name] || '0' : '0' };
            }, {} as Record<string, string>)
          };
        }),
        ...data.areaStatList.map(i => {
          return {
            ...i,
            schoolShortname: schoolAreaRecord[i.areaCode],
            ...data.scoreGroups.reduce((a, c) => {
              return { ...a, [c.name]: i.scoreGroupCountInfo ? i.scoreGroupCountInfo[c.name] || '0' : '0' };
            }, {} as Record<string, string>)
          };
        })
      ];
      if (data.amountStat) newList.push({
        ...data.amountStat,
        ...data.scoreGroups.reduce((a, c) => {
          return { ...a, [c.name]: data.amountStat.scoreGroupCountInfo ? data.amountStat.scoreGroupCountInfo[c.name] || '0' : '' };
        }, {} as Record<string, string>)
      });
      setList(newList);
    } finally {
      layer.closeLoading();
    }
  };

  const splitChange = (value: number) => {
    setSplit(value);
    load(value);
  };

  useEffect(() => {
    load(split);
  }, []);

  const downFile = () => {

    const c = columns.map(i => {
      if (i.dataIndex === 'schoolCode') {
        return {
          ...i,
          render: (value: string, record: unknown, index: number) => {
            if (index === 0) {
              return {
                children: value || '全市',
                props: {
                  colSpan: columns.length
                }
              };
            } else {
              return value;
            }
          }
        };
      } else {
        return {
          title: i.title,
          dataIndex: i.dataIndex,
          width: i.width || 80
        };
      }
    });

    const dataSource = [
      { schoolCode: decodeURI(name) + '-总分分段分析' },
      columns.reduce((a, curr) => {
        return {...a, [curr.dataIndex as string]: curr.title };
      }, {} as Record<string, string>),
      ...list.map(i => {
        return {
          ...i,
          areaCode: schoolAreaRecord[i.areaCode] || '全市'
        };
      })
    ] as unknown as any;
    exportFile({
      columns: c as unknown as any,
      dataSource: formatAnalysisTableRows(filterNull(dataSource), c) as unknown as any,
      showHeader: false,
      raw: true,
      onTxBodyRow: (_: unknown, index: number) => {
        if (index <= 1) {
          return {
            style: {
              borderStyle: 'thin',
              borderColorRgb: '000',
              alignmentHorizontal: 'center',
              fontBold: true,
              fontName: '宋体'
            }
          };
        }
        return {
          style: {
            borderStyle: 'thin',
            borderColorRgb: '000',
            alignmentHorizontal: 'center',
            fontName: '宋体'
          }
        };
      },
      fileName: decodeURI(name) + '-总分分段分析.xlsx'
    });
    addLogoPt(examid, decodeURI(name) + '-总分分段分析.xlsx');
  };

  return (
    <>
      <div className={style.title}>
        <div>总分分段分析</div>
        <Button onClick={downFile}>导出</Button>
      </div>
      <div className={style.table}>
        <Wrapper>
          <div className={style.searchPanel}>
            <span>分数段：</span>
            <Radio.Group value={split} onChange={e => splitChange(e.target.value)}>
              <Radio.Button value={5}>5</Radio.Button>
              <Radio.Button value={10}>10</Radio.Button>
              <Radio.Button value={50}>50</Radio.Button>
              <Radio.Button value={100}>100</Radio.Button>
            </Radio.Group>
            <span>分/段</span>
          </div>
          <div className={`${style.tableWrapper} ${style['split']}`}>
            <table className={style.uniTable}>
              <thead>
                <tr>
                  {
                    columns.map((i, index) => (
                      <th
                        key={index}
                        style={{width: `${i.width || 80}px`,height: '50px'}}
                      >
                        {i.title}
                      </th>
                    ))
                  }
                </tr>
              </thead>
              <tbody>
                {
                  list.map((i, index) => (
                    <tr key={index}>{
                      columns.map(c => (
                        <td key={c.title}>
                          {
                            formatAnalysisTableValue(c.render ? c.render(1, i as AllCourseSplitSchoolStat, index) : i[c.dataIndex as string], c) as unknown as any
                          }
                        </td>
                      ))
                    }</tr>
                  ))
                }
                {
                  list.length === 0 && <tr><td colSpan={columns.length}>暂无数据</td></tr>
                }
              </tbody>
            </table>
          </div>
        </Wrapper>
      </div>
    </>
  );
};

export default AllCourseSplit;
